import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-menu',
  templateUrl: './content-menu.component.html',
  styleUrls: ['./content-menu.component.scss']
})
export class ContentMenuComponent implements OnInit {
  menuDisplay = [
    {
      name: 'Project Management',
      route: '/project/project-settings-dashboard',
      icon: 'gisp_profile',
      iconType: 'material',
      // permission: ['ROLE_WORK_AS_DEPT_SUPERVISOR','ROLE_WORK_AS_SECOND_LEVEL',
      // 'ROLE_WORK_AS_FIRST_LEVEL', 'ROLE_WORK_AS_HD_DEPT_SUPERVISOR', 'ROLE_VIEW_INCIDENT']
    },

    {
      name: 'Annual Procurement Plan',
      route: '/assets', //change-management
      icon: 'gisp_project',
      iconType: 'material',
      // permission: ['ROLE_MANAGE_RESOURCE']
    },

    {
      name: 'Financial Plan',
      route: '/financial-planning/',
      icon: 'gisp_warning',
      iconType: 'material',
      // permission: ['ROLE_WORK_AS_FIRST_LEVEL', 'ROLE_WORK_AS_HD_DEPT_SUPERVISOR']
    },
    {
      name: 'Contract management',
      route: '/institution',
      icon: 'gisp_home',
      iconType: 'material',
      // permission: ['ROLE_INSTITUTION_MANAGEMENT']
    },
    {
      name: 'KPIs',
      route: '/reports',
      icon: 'gisp_standard',
      iconType: 'material',
      // permission: ['ROLE_GENERATE_REPORT']
    },
    {
      name: 'Reports',
      route: '/roster',
      icon: 'gisp_project_1',
      iconType: 'material',
      permission: ['ROLE_CALL_REGISTRY_MANAGEMENT']
    },
    {
      name: 'Accounts Manager',
      route: '/uaa',
      icon: 'settings',
      iconType: 'SVG',
      // permission: ['ROLE_MANAGE_INCIDENT_SETTINGS','ROLE_INSTITUTION_MANAGEMENT']
    },
    {
      name: 'System Settings',
      route: '/settings',
      icon: 'settings',
      iconType: 'SVG',
      // permission: ['ROLE_MANAGE_INCIDENT_SETTINGS','ROLE_INSTITUTION_MANAGEMENT']
    },

  ]
  constructor() { }

  ngOnInit(): void {
  }

}
